import { Stack } from "expo-router";
import { RequireCameraKey } from "@src/components/web/RequireCameraKey.web";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { ContactsScreen } from "@src/features/contacts/screens/ContactsScreen";

export default function CameraActivityNotificationWebRoute() {
  return (
    <RequireCameraKey requireSiteId>
      {() => (
        <>
          <Stack.Screen options={{ headerShown: false }} />
          <WebLayout>
            <ContactsScreen title="Notification settings" category="activity" />
          </WebLayout>
        </>
      )}
    </RequireCameraKey>
  );
}
